/* @flow */

import React from 'react';
import decorator from 'lib/lang/decorator';
import {action, observable} from 'mobx';
import {observer} from 'mobx-react';
import {getTag, getData} from 'exif-js';

export default decorator(() => Component => {

    @observer
    class WithFileThumbnailView extends React.Component {
        @observable url = null;
        @observable orientation;

        cleanup = () => {
            this.orientation = null;

            if (this.url) {
                URL.revokeObjectURL(this.url);
                this.url = null;
            }
        }

        @action create = (props = this.props) => {
            const {file} = props;

            this.cleanup();

            if (file) {
                if (file.type.startsWith('image')) {
                    const callback = () => {
                        try {
                            this.url = URL.createObjectURL(file);
                        } catch (e) {
                            console.warn(e);
                        }
                    };

                    if (file.type.startsWith('image/jpeg') || file.type.startsWith('image/tiff')) {
                        const that = this;

                        getData(file, function () {
                            that.orientation = getTag(this, 'Orientation');
                            callback();
                        });
                    } else {
                        callback();
                    }
                }
            }
        }

        componentDidMount() {
            this.create();
        }

        componentWillReceiveProps(props) {
            if (props.file !== this.props.file) {
                this.create(props);
            }
        }

        componentWillUnmount() {
            this.cleanup();
        }

        render() {
            return (
                <Component
                    {...this.props}
                    url={this.url}
                    orientation={this.orientation}
                    />
            );
        }
    }

    return WithFileThumbnailView;
});
